// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"502":"ucare-panel-chunk","868":"ucare-widget-chunk"}[chunkId] || chunkId) + "." + {"502":"20df1801","609":"c8397493","868":"d46fe3a6","929":"6596d429"}[chunkId] + ".chunk.js";
};